var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"test0"},[_c('span',[_vm._v("Ebenentransparenz")]),_c('v-slider',{attrs:{"color":"onprimary","prepend-icon":"opacity","value":_vm.layer.getOpacity(),"min":"0","max":"1","step":"0.01","thumb-label":"","hide-details":"","show-ticks":"always","track-size":"8"},on:{"input":_vm.onOpacitySliderInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }